import moment from "moment";
import React from "react";
import { FiArrowRight } from "react-icons/fi";
import { AiFillGift } from "react-icons/ai";

const ItemDetailsTop = ({ itemInfo, rewardInfo, showRewardModal }) => {
  return (
    <div className="item-details-top-wrapper">
      <div className="item-details-top-container">
        <div className="item-details-top-images-container">
          {itemInfo.users
            .filter((user) => user.id !== itemInfo.to.id)
            .map((user, index) => (
              <img
                src={
                  user.avatar ||
                  require("../../../assets/images/blank-profile.png")
                }
                alt="profile"
                key={user.id}
              />
            ))}
        </div>
        <p>
          <FiArrowRight size={20} color="#000000" />
        </p>
        <div className="item-details-top-user-image-container">
          <img
            src={
              itemInfo.to.avatar ||
              require("../../../assets/images/blank-profile.png")
            }
            alt="user"
          />
        </div>
      </div>
      <p className="item-details-top-reason-title">{itemInfo.reason}</p>
      <p className="item-details-top-payment-title">
        {itemInfo.users
          .filter((user) => user.id !== itemInfo.to.id)
          .map(
            (user, index) =>
              user.name +
              (index === itemInfo.users.length - 1
                ? " & "
                : index === itemInfo.users.length - 2
                ? " "
                : ", ")
          )}
        owe &nbsp;
        {itemInfo.to.name}
      </p>
      {rewardInfo && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            className="item-details-top-reward-container"
            onClick={showRewardModal}
          >
            <AiFillGift size={20} color="#007fFF" />
            <p>{rewardInfo.name}</p>
          </div>
        </div>
      )}

      <div className="item-details-top-payment-details-container">
        <p>
          <span>Started:</span>{" "}
          <span>{moment(itemInfo.createdAt).format("ll")}</span>
        </p>
        <p style={{ color: itemInfo.paid ? "#00A86B" : "#FF007F" }}>
          {itemInfo.paid ? "Paid" : "Unpaid"}
        </p>
        {!itemInfo.paid && (
          <p>
            <span>Due:</span>{" "}
            <span
              style={{
                color: moment(itemInfo.dueDate).isBefore(moment())
                  ? "#FF007F"
                  : "#000000",
              }}
            >
              {moment(itemInfo.dueDate).fromNow()}
            </span>
          </p>
        )}
      </div>
    </div>
  );
};

export default ItemDetailsTop;
